/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VacationRequestsFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    userId?: boolean;
    code?: boolean;
    startDate?: boolean;
    endDate?: boolean;
    totalDays?: boolean;
    selectedDates?: boolean;
    status?: boolean;
    approverBossId?: boolean;
    approvedByBossAt?: boolean;
    bossComments?: boolean;
    payrollApproverId?: boolean;
    approvedByPayrollAt?: boolean;
    payrollComments?: boolean;
    manualApproverId?: boolean;
    manualApproverReason?: boolean;
    rejectedById?: boolean;
    rejectedAt?: boolean;
    rejectionReason?: boolean;
    cancelledAt?: boolean;
    cancellationReason?: boolean;
    employeeComments?: boolean;
    balanceSnapshot?: boolean;
    hrNotified?: boolean;
    hrNotifiedAt?: boolean;
    notifyStartOn?: boolean;
    notifyEndOn?: boolean;
    crossesAnniversary?: boolean;
    daysInCurrentPeriod?: boolean;
    daysInNextPeriod?: boolean;
    isAdvance?: boolean;
    advanceDays?: boolean;
    advanceReason?: boolean;
    advanceAuthorizedBy?: boolean;
    advanceAuthorizedOn?: boolean;
}

